import React, { useState, useEffect, useContext } from 'react'

import Header from '../../components/Header'
import SubMenu from '../../components/SubMenu'

import styles from './Producto.module.css'
import Footer from '../../components/Footer'
import ProductoCard from './ProductoCard'
import Subtitle from '../../components/Subtitle'

//Context
import GeneralContext from '../../context/GeneralContext'
import * as GeneralActions from '../../store/actions/generalActions'
import * as ProductoRepository from "../../services/repositories/producto-repository";
import { obtenerPagoRecurrente, actualizarPagoRecurrente } from "../../services/repositories/pago-recurrente-repository";
import { COD_PRODUCTO_VIDA_INVERSION_CAPITAL,
         COD_MONEDA_DOLARES, COD_MONEDA_SOLES,
         COD_COBRANZA_DIRECTA, COD_DEFAULT_OPERADOR_TARJETA } from '../../utils/constantes';
import { obtenerRequisitos } from "../../services/repositories/requisito-repository"

const initialValues = {
  estaCargando: true,
  errorCargando: null,
  reloadValidacion: false,
  productos: null
}

const Producto = ({ history }) => {
  const [state, setState] = useState(initialValues)
  const [ paymentList, setPaymentList] = useState([]);
  const [usarMismoMedioPago, setUsarMismoMedioPago]= useState()
  const [enabledPagoRecurrente, setEnabledPagoRecurrente] = useState(false)
  const [hasRequirements, setHasRequirements] = useState([])
  const { state: generalState, dispatch: generalDispatch } = useContext(GeneralContext)
  let user = generalState.users.filter(user => user.isAuthenticated)[0]
  let prospecto = user.listaProspectos.filter(prospecto => prospecto.isSelected || prospecto.completado)[0]
  let cotizacion = prospecto.cotizaciones.filter(cotizacion => cotizacion.isSelected || cotizacion.completado)[0]

  useEffect(() => {
    cargarDatosIniciales()
  }, [])

  useEffect(() => {
   if(state.productos && user.info){ 
    const mappedPaymentList = state.productos.map(producto => ({
      codigoTipoCobranza: COD_COBRANZA_DIRECTA,
      codigoOperadorTarjeta: COD_DEFAULT_OPERADOR_TARJETA,
      codigoTipoCuenta: null,
      numeroTarjeta: "",
      fechaVencimiento: "",
      usuario: user.info.IdUsuario,
      idSolicitud: producto.idSolicitud,
      codMoneda: producto.moneda === "Dolares" ? COD_MONEDA_DOLARES : COD_MONEDA_SOLES,
    }));

    setPaymentList(mappedPaymentList);}
  }, [state.productos, user.info.IdUsuario]);


 const getPagoRecurrente = async () => {
    const response = await obtenerPagoRecurrente(cotizacion.idSolicitudMultiple);

    if (!response.error) {
      setUsarMismoMedioPago(response.pagoRecurrente?.usarMismoMedioPago);
      const hasDifferentCodigoTipoCobranza = response.pagoRecurrente.pagoRecurrente.some(item => item.codigoTipoCobranza !== 4);
      setEnabledPagoRecurrente(hasDifferentCodigoTipoCobranza);
    } else {
      generalDispatch(GeneralActions.updateError(response.error, '¡Alerta!', true));
    }
};

const getRequisitos = async () => {
  const resRequisitos = await obtenerRequisitos(cotizacion.idSolicitudMultiple)
  if (!resRequisitos.error) {
    setHasRequirements(resRequisitos.requisitos.examenes)
  } else {
    generalDispatch(GeneralActions.updateError(resRequisitos.error, '¡Alerta!', true));
  }
}

const nextPage = (requirement) => {
  if(requirement){
    return '/requisitos'
  }else{
    return '/firma'
  }
};

  const cargarDatosIniciales = async () => {
    const obtenerListaProductos = async () => {
      const response = await ProductoRepository.listarProductos(cotizacion.idSolicitudMultiple)
      if(response.error === null) {
        setState((state) => {
          return {
            ...state,
            productos: response.productos
          }
        })
      } else {
        generalDispatch(GeneralActions.updateError(response.error, '¡Alerta!', true))
      }
    }

    generalDispatch(GeneralActions.updateEstadoCargando(true))
    await obtenerListaProductos()
    generalDispatch(GeneralActions.updateEstadoCargando(false))
    getPagoRecurrente()
    getRequisitos()
  }

  const [mover, setMover] = useState(false)
  const mueveContenido = (valor) => {
    setMover(valor)
  }


  const updatePagoRecurrente = () => {
    const sentUsarMismoMedioPago = usarMismoMedioPago ? usarMismoMedioPago : false;
    const response = actualizarPagoRecurrente(cotizacion.idSolicitudMultiple, paymentList, sentUsarMismoMedioPago);
    if(response.error) {
      generalDispatch(GeneralActions.updateError(response.error, '¡Alerta!'))
      return false
    }

    history.push(nextPage( Boolean(hasRequirements?.length)))
  }

  const handleValidarPantalla = () => {
    generalDispatch(GeneralActions.continuarProceso(history.location.pathname))
    history.push(nextPage( Boolean(hasRequirements?.length)))
  }

  return (
    <div>
      <Header history={history} />
      <SubMenu history={history} modal={state.estaCargando} desplaza={mueveContenido} />
      <section className={styles['areadatosusuario']}
        style={mover ? { width: '93%', paddingLeft: '6.5%', height: '100vh' } : {}}
      >
        <div className={styles['areadatosprospecto']}>
          <Subtitle
            sname='Los productos que protegerán a tu familia son:'
            smostrar={true}
            sparrafo='Detalles de los productos'
          />
          {state.productos
            ? state.productos.map((item) => (
              <ProductoCard key={item.codigoProducto} producto={item} />
            ))
            : null}
        </div>

        <Footer history={history} validarPantalla={handleValidarPantalla}/>
      </section>
    </div>
  )
}

export default Producto
